import { useCallback, useMemo } from 'react';
import ArtifactChip from 'breeze-artifacts-sdk/chip/ArtifactChip';
import { jsx as _jsx } from "react/jsx-runtime";
// resolvedArtifactId/resolvedVersionId backfill legacy filesystem artifacts
// that predate persisted write metadata - a host that can resolve them (e.g.
// chatspot, via the artifact list) passes them in so a plugin's CHIP
// contribution can fetch this specific version's real content; hosts that
// can't simply omit them.
function toArtifactData(block, resolvedArtifactId, resolvedVersionId) {
  var _block$artifactId, _block$version;
  const artifactId = (_block$artifactId = block.artifactId) !== null && _block$artifactId !== void 0 ? _block$artifactId : resolvedArtifactId;
  return {
    id: artifactId != null ? String(artifactId) : '',
    artifactType: block.artifactType,
    title: block.name,
    // Freshly-streamed chat blocks are active by construction - there is no
    // archived/sent lifecycle representable in a chat block, and no live
    // status source at this layer.
    status: 'ACTIVE',
    currentVersion: (_block$version = block.version) !== null && _block$version !== void 0 ? _block$version : 0,
    metadata: {
      path: block.path,
      versionId: block.versionId || resolvedVersionId,
      source: block.source
    }
  };
}
export function ArtifactBlock({
  block,
  onArtifactClick,
  disableArtifacts,
  isInCanvasView,
  resolvedArtifactId,
  resolvedVersionId,
  disabledTooltip
}) {
  const artifactBlock = block;
  const artifactData = useMemo(() => toArtifactData(artifactBlock, resolvedArtifactId, resolvedVersionId), [artifactBlock, resolvedArtifactId, resolvedVersionId]);

  // The chip's own CHIP contribution parses whatever shape it needs out of
  // `content`; it comes from the block's serialized payload (the stream-
  // derived fallback when no live version fetch runs), not a per-type
  // decision here.
  const content = artifactBlock.payload ? JSON.stringify(artifactBlock.payload) : undefined;
  const handleArtifactClick = useCallback(__artifact => {
    onArtifactClick === null || onArtifactClick === void 0 || onArtifactClick(artifactBlock);
  }, [onArtifactClick, artifactBlock]);
  return /*#__PURE__*/_jsx(ArtifactChip, {
    artifact: artifactData,
    content: content,
    onArtifactClick: onArtifactClick ? handleArtifactClick : undefined,
    disableArtifacts: disableArtifacts,
    isInCanvasView: isInCanvasView,
    disabledTooltip: disabledTooltip
  });
}